import React from 'react'
import { Dropdown, DropdownButton, MenuItem } from 'react-bootstrap'
import { useLocale } from '@transifex/react'
import useOutsideClick from '../../hooks/useOutsideClick'
import { changeLanguage } from '../../transifex/transifex'

const LanguageButton = () => {
  const locale = useLocale()

  const { ref, isOpen, setIsOpen } = useOutsideClick(false)

  const flags = {
    sv: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SE.svg',
    en: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg',
  }

  const handleLanguageClick = (eventKey) => {
    changeLanguage(eventKey)
    setIsOpen(false)
  }

  return (
    <div className="flex language-btn" ref={ref}>
      {isOpen ? (
        <Dropdown id="dropdown" onClick={() => setIsOpen(!isOpen)}>
          <DropdownButton show={String(isOpen)} defaultOpen pullRight bsSize="xs" title="" id="dropdown-btn">
            <MenuItem onSelect={() => handleLanguageClick('sv')}>
              <img width={'30px'} src={flags.sv} />
            </MenuItem>
            <MenuItem onSelect={() => handleLanguageClick('en')}>
              <img width={'30px'} src={flags.en} />
            </MenuItem>
          </DropdownButton>
        </Dropdown>
      ) : (
        <img src={flags[locale]} width={'30px'} onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer' }}></img>
      )}
    </div>
  )
}

export default LanguageButton
